import cardValidator from 'card-validator';
import { validateEmail, validateInternationalPostalCode } from '../../Shared/validations';

import { copyFor } from '../../../copy/copy';
import { PaymentMethod } from '../../../utils/enums';

const validateFullName = values => {
    if (values.fullName == null || values.fullName === '') {
        return { fullName: copyFor('validationErrors', 'fullName', 'email') };
    }
    const split = values.fullName.split(' ');

    if (split.length > 1 && split[0] !== '' && split[1] !== '') return {};

    return { fullName: copyFor('validationErrors', 'fullName', 'email') };
};

const validateCard = values => {
    const creditCardValidation = cardValidator.number(values.cardNumber);
    if (!creditCardValidation.isValid) {
        return { cardNumber: 'Invalid Credit Card Number' };
    } else {
        if (
            creditCardValidation.card &&
            creditCardValidation.card.code &&
            creditCardValidation.card.code.size
        ) {
            const cvvValidation = cardValidator.cvv(
                values.cvv,
                creditCardValidation.card.code.size
            );

            if (!cvvValidation.isValid) {
                return { cvv: 'Invalid CVV' };
            }
        }
    }
    return {};
};

export const validateCvv = values => {
    const onlyNums = /^\d*$/;
    if (values.cvv == null || values.cvv === '' || onlyNums.exec(values.cvv) === false) {
        return { cvv: copyFor('validationErrors', 'cvv') };
    }
    return {};
};

const validateDate = values => {
    const dateValidation = cardValidator.expirationDate(values.expDate);
    if (!dateValidation.isValid) {
        return { expDate: 'Invalid Date' };
    }
    return {};
};

const validation = (values, props) => {
    var validations = {
        ...validateInternationalPostalCode(values),
        ...validateEmail(values),
        ...validateFullName(values)
    };

    if (props.paymentMethod !== PaymentMethod.OrgHunter) {
        validations = {
            ...validations,
            ...validateDate(values),
            ...validateCard(values),
            ...validateCvv(values)
        };
    }
    return validations;
};

export default validation;
